import { Calendar, List, Handshake, User } from 'lucide-react';
import { Link, useLocation } from 'react-router';

const tabs = [
  { id: 'evenimente', icon: List, label: 'Evenimente', path: '/evenimente', match: ['/evenimente', '/eveniment'] },
  { id: 'calendar', icon: Calendar, label: 'Calendar', path: '/calendar', match: ['/calendar', '/zi'] },
  { id: 'parteneri', icon: Handshake, label: 'Prieteni', path: '/parteneri', match: ['/parteneri', '/partener'] },
  { id: 'cont', icon: User, label: 'Cont', path: '/cont', match: ['/cont'] },
];

export function BottomNav() {
  const location = useLocation();

  function isActive(tab: typeof tabs[number]): boolean {
    if (tab.id === 'evenimente' && location.pathname === '/') return true;
    return tab.match.some((m) => location.pathname.startsWith(m));
  }

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 border-t bg-white shadow-lg md:hidden">
      <div className="mx-auto max-w-7xl">
        <div className="flex items-center justify-around px-2 py-1.5">
          {tabs.map((tab) => {
            const active = isActive(tab);
            const Icon = tab.icon;

            return (
              <Link
                key={tab.id}
                to={tab.path}
                className="flex flex-1 flex-col items-center gap-0.5 rounded-xl px-3 py-1.5 transition-all active:scale-95"
                style={{
                  backgroundColor: active ? '#f0e8ff' : 'transparent',
                }}
                aria-label={tab.label}
                aria-current={active ? 'page' : undefined}
              >
                <Icon
                  className="h-5 w-5"
                  style={{ color: active ? '#3b0b86' : '#717182' }}
                />
                <span
                  className="text-[10px] font-medium"
                  style={{
                    color: active ? '#3b0b86' : '#717182',
                    fontFamily: 'var(--font-secondary)',
                  }}
                >
                  {tab.label}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
      {/* Safe area for iOS */}
      <div className="h-[env(safe-area-inset-bottom)]" />
    </nav>
  );
}
